import { LabelHTMLAttributes, forwardRef } from 'react';
import { cn } from '../../lib/utils';

/**
 * Label — Strict form field label with consistent typography.
 */
export const Label = forwardRef<HTMLLabelElement, LabelHTMLAttributes<HTMLLabelElement>>(
    ({ className, children, ...rest }, ref) => (
        <label
            ref={ref}
            className={cn('text-xs font-bold text-slate-600 select-none', className)}
            {...rest}
        >
            {children}
        </label>
    )
);
Label.displayName = 'Label';

/**
 * FormError — Inline field-level error message.
 */
export const FormError = ({ message, className }: { message?: string; className?: string }) => {
    if (!message) return null;
    return (
        <p className={cn('text-xs font-medium text-red-500', className)}>{message}</p>
    );
};
